import { NavigationBar } from "../shared/Navigation";
import { Footer } from "../shared/Footer";
import { HeroSection } from "./HeroSection";
import { FeaturesSection } from "./FeaturesSection";
import { FeaturedCarsSection } from "./FeaturedCarsSection";
import { HowItWorksSection } from "./HowItWorksSection";
import type { Car } from "../Listings";

interface HomeProps {
  onNavigate: (page: string) => void;
  onCarSelect: (car: Car) => void;
  onCarBuy: (car: Car) => void;
  onContactClick: () => void;
  onOpenTerms: () => void;
  onOpenPrivacy: () => void;
}

export function Home({ 
  onCarSelect, 
  onCarBuy, 
  onContactClick, 
  onOpenTerms, 
  onOpenPrivacy 
}: HomeProps) {
  return (
    <div className="min-h-screen">
      <NavigationBar onContactClick={onContactClick} />
      <HeroSection />
      <FeaturesSection />
      <FeaturedCarsSection onCarSelect={onCarSelect} onCarBuy={onCarBuy} />
      <HowItWorksSection onCarBuy={onCarBuy} />
      <Footer onOpenTerms={onOpenTerms} onOpenPrivacy={onOpenPrivacy} />
    </div>
  );
}